import { TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DraggableDialog from "components/draggagle-dialog";
import MDTypography from "components/MDTypography";
import { useState } from "react";

/**
 * Modal component for rejecting subscription extend requests
 * @param {Object} props - Component props
 * @param {boolean} props.openState - Modal open state
 * @param {function} props.handleFormClose - Function to close modal
 * @param {Object} props.selectedRequest - Selected request data
 * @param {function} props.onReject - Function to handle reject action
 * @param {boolean} props.isLoading - Loading state
 */
const RejectRequestModal = ({ openState, handleFormClose, selectedRequest, onReject, isLoading }) => {
  const [description, setDescription] = useState("");

  const handleSubmit = () => {
    if (description.trim()) {
      onReject(description.trim());
      setDescription("");
    }
  };

  return (
    <DraggableDialog
      open={openState}
      onClose={handleFormClose}
      dialogTitle="Reject Subscription Extension Request"
      dialogContent={
        <MDBox>
          {/* Request Details */}
          <MDBox mb={3}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              Request #{selectedRequest?.id} - {selectedRequest?.tenant?.company_name}
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text" display="block">
              Plan: {selectedRequest?.subscription?.plan?.name}
            </MDTypography>
          </MDBox>

          {/* Rejection Description */}
          <MDBox mb={3}>
            <MDTypography variant="h6" fontWeight="medium" mb={1}>
              Rejection Description
            </MDTypography>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Please provide a detailed reason for rejection..."
              error={!description.trim()}
              helperText={!description.trim() ? "Description is required" : ""}
            />
          </MDBox>
        </MDBox>
      }
      dialogActions={
        <MDBox display="flex" justifyContent="flex-end" gap={2}>
          <MDButton 
            variant="outlined" 
            color="dark"
            onClick={handleFormClose}
            disabled={isLoading}
          >
            Cancel
          </MDButton>
          <MDButton
            color="error"
            onClick={handleSubmit}
            disabled={isLoading || !description.trim()}
          >
            {isLoading ? "Processing..." : "Reject Request"}
          </MDButton>
        </MDBox>
      }
    />
  );
};

export default RejectRequestModal;